export const STORAGE_KEY = "boostscience_observatory_assessment_v2";
export const PREFS_KEY = "boostscience_observatory_prefs_v1";
export const LEAD_KEY = "boostscience_observatory_lead_v1";

export interface AssessmentState {
  version: 1;
  field?: "biology" | "chemistry" | "interdisciplinary";
  stage?: string;
  clusterId?: string;
  careerId?: string;
  answers: Record<string, number>;
  priorityGroupIds: string[];
  step: number;
  questionIndex?: number;
  completedAt?: string;
}

export interface LeadSession {
  email: string;
  marketingConsent: boolean;
  capturedAt: string;
}

export function emptyAssessment(): AssessmentState {
  return { version: 1, answers: {}, priorityGroupIds: [], step: 1, questionIndex: 0 };
}
export function loadAssessment(): AssessmentState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AssessmentState;
    if (parsed.version !== 1) return null;
    return { ...parsed, questionIndex: Number.isFinite(parsed.questionIndex) ? parsed.questionIndex : 0 };
  } catch {
    return null;
  }
}

export function saveAssessment(state: AssessmentState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearAssessment(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function loadLeadSession(): LeadSession | null {
  try {
    const raw = sessionStorage.getItem(LEAD_KEY);
    return raw ? (JSON.parse(raw) as LeadSession) : null;
  } catch {
    return null;
  }
}
export function saveLeadSession(lead: LeadSession): void {
  sessionStorage.setItem(LEAD_KEY, JSON.stringify(lead));
}

export function loadPrefs(): { radarView?: "radar" | "list" } {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    return raw ? (JSON.parse(raw) as { radarView?: "radar" | "list" }) : {};
  } catch {
    return {};
  }
}

export function savePrefs(prefs: { radarView?: "radar" | "list" }): void {
  localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
}
